import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MultiSelectComponent} from './multi-select.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TagsModule } from '../tags/tags.module';
import {ClickOutsideModule} from '../../directives/click-outside/click-outside.module';
import {TranslateModule} from '@ngx-translate/core';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { ButtonModule } from '../button/button.module';


@NgModule({
  declarations: [MultiSelectComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        CheckboxModule,
        TagsModule,
        ClickOutsideModule,
        TranslateModule
    ],
  exports: [MultiSelectComponent,ButtonModule]
})
export class MultiSelectModule { }
